import React, { useEffect } from 'react'
import { Grid, Typography, Button } from '@material-ui/core'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline'
import { useGlobalState } from '../provider/Provider'
import { useHistory, useRouteMatch } from 'react-router-dom'
import { getUncontractList, typeUncontract } from '../api/helpline/mikeiyaku'
import UncontractListTable from '../component/portal/uncontractlist/UncontractListTable'


interface Prop {
  handleError: (err: any) => void,
}

const UncontractList: React.FC<Prop> = (props) => {
  const globalState = useGlobalState('user')
  const { userId, token, role } = globalState
  let { path } = useRouteMatch()
  const history = useHistory()
  const { handleError } = props

  const [uncontract, setUncontract] = React.useState<typeUncontract[]>()

  const handleClickCreate = () => {
    history.push(`${path}/create`)
  }

  const handleClickUser = (usercd: string) => {
    history.push(`${path}/${btoa(usercd)}`)
  }

  const sortAsc = (list: typeUncontract[]) => {
    list.sort((a, b) => {
      if (a.userNameSyllabary > b.userNameSyllabary) {
        return 1;
      } else {
        return -1;
      }
    })
    return list
  }

  useEffect(() => {
    let cleanup = false
    if (userId && token && role) {
      getUncontractList(userId, token, role, '').then(res => {
        if (res.length !== 0 && !cleanup) {
          setUncontract(sortAsc(res))
        }
      }).catch(err => handleError(err))
    }
    return () => { cleanup = true }
  }, [])

  return (
    <React.Fragment>
      <Grid container direction="row" justify="flex-start">
        <Typography variant="h6" style={{ flexGrow: 1 }}>
          未契約顧客一覧
      </Typography>
        <Button variant="outlined" color="primary" size="small" startIcon={<AddCircleOutlineIcon />} onClick={handleClickCreate}>
          新規登録
        </Button>
      </Grid>
      <Grid container spacing={2} justify="center" >
        <Grid item xs={11}>
          <UncontractListTable uncontract={uncontract} handleClickUser={handleClickUser} />
        </Grid>
      </Grid>
    </React.Fragment >
  )
}

export default UncontractList
